// extracted by mini-css-extract-plugin
export default {"root":"CookingImagesPage_root__7JrJM","image-results":"CookingImagesPage_image-results__BVaEj","fallback":"CookingImagesPage_fallback__GlOyu"};